import React from 'react';
import { constructUrl } from '../../../../utils/UrlConstructor';

import '../../add-to-cart/CartItem.css'

const WishlistEmailCartItem = ({ name, price, thumbnail, menuTextFontStyle, prefix }) => {
    const updatedFontStyle = {
        ...menuTextFontStyle,
        fontSize: 12
    }
    return (
        <React.Fragment>
            <div className='cart-item-container' style={{ flexDirection: 'column' }}>
                {thumbnail && <img className='cart-item-thumbnail' style={{ marginBottom: '4px' }} src={constructUrl(thumbnail)} />}
                {!thumbnail && <div className='cart-item-thumbnail'>&nbsp;</div>}
                <div className='cart-item-info' style={updatedFontStyle}>
                    <span>{name}</span>
                    <span>{`${prefix}${price}.00`}</span>
                </div>
            </div>
            <hr className="cart-item-break" />
        </React.Fragment>
    )
}

export default WishlistEmailCartItem;
